import React from 'react';
import { func, string } from 'prop-types';
import { paymentMethodType } from 'types';

import Button from 'ui/Button';

import { MdFiberManualRecord as Circle, MdDelete } from 'react-icons/md';
import AmericanExpress from 'icons/AmericanExpress';
import Generic from 'icons/Generic';
import DinersClub from 'icons/DinersClub';
import Discover from 'icons/Discover';
import Jcb from 'icons/Jcb';
import MasterCard from 'icons/MasterCard';
import UnionPay from 'icons/UnionPay';
import Visa from 'icons/Visa';

import { formatMonthYear } from 'utils/dates';
import { CARD_BRANDS } from 'utils/constants';

import * as styles from './styles';

const { AMEX, DINERS, DISCOVER, JCB, MASTERCARD, VISA, UNION } = CARD_BRANDS;

export const renderPaymentMethodLogo = (brand, width = 50) => {
  switch (brand) {
    case AMEX:
      return <AmericanExpress data-testid={AMEX} width={width} />;
    case DINERS:
      return <DinersClub data-testid={DINERS} width={width} />;
    case DISCOVER:
      return <Discover data-testid={DISCOVER} width={width} />;
    case JCB:
      return <Jcb data-testid={JCB} width={width} />;
    case MASTERCARD:
      return <MasterCard data-testid={MASTERCARD} width={width} />;
    case VISA:
      return <Visa data-testid={VISA} width={width} />;
    case UNION:
      return <UnionPay data-testid={UNION} width={width} />;
    default:
      return <Generic data-testid="generic" width={width} />;
  }
};

const PaymentMethod = ({
  className,
  paymentMethod,
  showDeletePaymentMethodToastr
}) => {
  const { brand, exp_month, exp_year, id, last4, name } = paymentMethod;

  const expiration = formatMonthYear(exp_month, exp_year);

  return (
    <styles.Wrapper className={className} data-testid={`paymentMethod-${id}`}>
      <styles.Header>
        {renderPaymentMethodLogo(brand)}
        <styles.Last4Wrapper>
          <span>
            <Circle />
            <Circle />
            <Circle />
            <Circle />
          </span>
          {last4}
        </styles.Last4Wrapper>
        <styles.ConditionallyHidden>{expiration}</styles.ConditionallyHidden>
        <styles.ConditionallyHidden>{name}</styles.ConditionallyHidden>
        <div>
          <styles.DeleteButton
            as={Button}
            data-testid={`deletePaymentMethodBtn-${id}`}
            name="deletePaymentMethodBtn"
            onClick={() => showDeletePaymentMethodToastr(id)}
          >
            <MdDelete />
          </styles.DeleteButton>
        </div>
      </styles.Header>
      <styles.Body>
        <ul>
          <li>
            <span>Expiration</span>
            <span>{expiration}</span>
          </li>
          <li>
            <span>Name on card</span>
            <span>{name}</span>
          </li>
        </ul>
      </styles.Body>
    </styles.Wrapper>
  );
};

PaymentMethod.propTypes = {
  className: string,
  paymentMethod: paymentMethodType.isRequired,
  showDeletePaymentMethodToastr: func.isRequired
};

export default PaymentMethod;
